export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M6.29 9L1 14.29V11.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v4c0 .14.06.26.15.35.11.11.25.16.39.15H4.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H1.71L7 9.71c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0zM15.85.15a.497.497 0 00-.39-.15H11.5c-.28 0-.5.22-.5.5s.22.5.5.5h2.79L9 6.29c-.2.2-.2.51 0 .71.2.2.51.2.71 0L15 1.71V4.5c0 .28.22.5.5.5s.5-.22.5-.5v-4a.49.49 0 00-.15-.35z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};